/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ billable: NonNullable<unknown>, accruing: NonNullable<unknown>, month: NonNullable<unknown> }} Partner_Billing_Board_Alltime_SplitInputs */



/**
* | output |
* | --- |
* | "{billable} billable now (closed months) · {accruing} accruing in {month} (open month)" |
*
* @param {Partner_Billing_Board_Alltime_SplitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_alltime_split = /** @type {((inputs: Partner_Billing_Board_Alltime_SplitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Alltime_SplitInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.billable} jetzt fakturierbar (abgeschlossene Monate) · ${i?.accruing} laufend in ${i?.month} (offener Monat)`)
	return /** @type {LocalizedString} */ (`${i?.billable} billable now (closed months) · ${i?.accruing} accruing in ${i?.month} (open month)`)
});